import { useEffect, useState } from 'react';
import { Modal, Pagination } from 'antd';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../../../../utils/formatPrice';
import type { IViewRecordedPricesModal } from '../../../../../types/task';
import { PriceStatusEnum } from '../../../../../enums/PriceStatusEnum';

const ViewRecordedPricesModal = (props: IViewRecordedPricesModal) => {
  const { t } = useTranslation(['task', 'price']);
  const { isModalOpen, onCancel, prices } = props;

  const [currentPage, setCurrentPage] = useState<number>(1);
  const pageSize = 5;

  useEffect(() => {
    if (isModalOpen) {
      setCurrentPage(1);
    }
  }, [isModalOpen, prices]);

  const startIndex = (currentPage - 1) * pageSize;
  const paginatedPrices = prices?.slice(startIndex, startIndex + pageSize) || [];

  return (
    <Modal
      title={t('recordedPrice')}
      closable={{ 'aria-label': 'Custom Close Button' }}
      open={isModalOpen}
      onCancel={onCancel}
      footer={null}
      width={480}
      className="recorded-prices-modal"
    >
      {prices && prices?.length > 0 ? (
        <div className="space-y-3">
          <div className="max-h-[60vh] space-y-2 overflow-y-auto pr-1">
            {paginatedPrices?.map((priceItem, index) => {
              const isNotFound = priceItem?.status === PriceStatusEnum.PRODUCTNOTFOUND;

              return (
                <div
                  key={index}
                  className="flex items-center justify-between gap-3 rounded-lg border border-gray-100 bg-gray-50/75 p-3 text-sm transition-colors hover:bg-gray-50"
                >
                  <span className="flex-1 break-words font-medium text-gray-800">
                    {priceItem?.product}
                  </span>
                  <span className="shrink-0 rounded-md px-2.5 py-1 text-xs font-bold text-primary">
                    {isNotFound ? (
                      <span className="font-semibold text-red-500">{t('price:priceNotFound')}</span>
                    ) : (
                      formatPrice(priceItem?.price as number | string)
                    )}
                  </span>
                </div>
              );
            })}
          </div>

          {prices?.length > 0 && (
            <div className="flex justify-center pt-2">
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={prices.length}
                onChange={(page) => setCurrentPage(page)}
                size="small"
                showSizeChanger={false}
              />
            </div>
          )}
        </div>
      ) : (
        <div className="py-8 text-center text-sm text-gray-500">{t('noPriceDataFound')}</div>
      )}
    </Modal>
  );
};

export default ViewRecordedPricesModal;
